import { tv } from '@change/ds-utils';

export const completedTaskStyles = tv({
	slots: {
		checkboxWrapper: ['flex items-start gap-4 md:items-center md:gap-3'],
	},
});
